// extracted by mini-css-extract-plugin
export default {"lazy":"lazy_AMzH9"};